import React from "react";
import "./wmbutton.css";

function Wmbutton({ label, color, bordered, id, type, className, onClick, children,disable }) {
  return (
    <React.Fragment>
      {bordered ? (
        <button
          id={id}
          type={type}
          onClick={onClick}
          disabled={disable}
          className={`wmbutton-color-black h-10 border-background-white wm-border-1 border-solid ${className} ${color}`}
        >
          {children}
          {label}
        </button>
      ) : (
        <button
          id={id}
          type={type}
          onClick={onClick}
          disabled={disable}
          className={`wmbutton-color-white h-10 ${className} ${color}`}
        >
          {children}
          {label}
        </button>
      )}
    </React.Fragment>
  );
}

export default Wmbutton;
